import React, { useEffect, useState, useRef } from "react";
import {useTranslation} from "react-i18next";
import { IFeature } from '@esri/arcgis-rest-types';
import IReport from '../../../models/IReport';
import ConfigService from '../../../shared/configService';

export const PSReportList = (props: any) => {
  
    const {t} = useTranslation('psdashboard');

    const [state, setState] = useState({
        reports: props.reports,
        selectedPS:props.selectedPS
      });

    useEffect(() => {
        setState({
            reports: props.reports,
            selectedPS:props.selectedGID
        });
   
    }, []);
    
    return (
        <div className="containerReportList containerPSReportList">                       
            {               
                <div className="bg-darkgreen resultBoxPS">
                    <div className="contained">
                    <h2 className="country-list-title">Companies Reported</h2>
                        {
                            //state.reports.sort((a: any, b: any) => (a.company_name > b.company_name ? 1 : -1)).map((report:any, i: number) =>  
                            state.reports.map((report:any, i: number) =>                            
                                <ul className="list-of-countries">
                                    <li className="lstCountryData">
                                        <div className={`countryReport  ${(report==true)?"clickable":""}`}  key={`countryReport_${i}`}
                                                onClick={() => props.onClickedCompany(report)} > {report}
                                        </div>
                                    </li>
                                </ul>
                            )
                        }
                    </div>
                </div>
                
            }
        </div>
    )
}